import moment from "moment";
import { DATE_FORMAT, FORMAT } from "../constants/Constant";
import { isValidEmail } from "deskera-ui-library";
import Utility from "../utility/Utility";

class CustomSectionManager {
	static isEmpty(value) {
		if (value === null || value === undefined) {
			return true;
		} else if (typeof value === "string" && value.trim().length === 0) {
			return true;
		}

		return false;
	}

	static getCustomSectionFields(customSections) {
		const customSectionFields = [];
		customSections.forEach((section) => {
			if (Array.isArray(section.fields)) {
				section.fields.forEach((field) => {
					customSectionFields.push(field);
				});
			}
		});

		return customSectionFields;
	}

	static formatValue(type, value) {
		switch (type) {
			case "dropdown":
				return value instanceof Object ? value.id : value;
			case "date":
				return value instanceof Date ? moment(value).format(DATE_FORMAT.YYYYMMDD) : value;
			case "checkbox":
				return !this.isEmpty(value) ? value : false;
			default:
				return value;
		}
	}

	static getCustomSectionFieldValues(customSectionFields) {
		const customSectionFieldValues = {};
		if (Array.isArray(customSectionFields)) {
			customSectionFields.forEach((field) => {
				customSectionFieldValues[field.id] = this.formatValue(field.type, field.value)
			});
		}

		return customSectionFieldValues;
	}

	static parseValue(field, value) {
		switch (field.type) {
			case "dropdown":
				if (Array.isArray(field.defaultOptions)) {
					const option = field.defaultOptions.find((o) => {
						return o.id === value;
					});

					return option || value;
				}
				return value;
			case "date":
				const timeInMS = Date.parse(value);
				if (!isNaN(timeInMS)) {
					const date = new Date(timeInMS);
					return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
				}
				return value;
			case "checkbox":
				return !this.isEmpty(value) ? value : false;
			default:
				return value;
		}
	}

	static setCustomSectionFieldValues(customSections, customSectionFieldValues) {
		const customSectionsToUpdate = [...customSections];
		customSectionsToUpdate.forEach((section) => {
			if (Array.isArray(section.fields)) {
				const fieldsToUpdate = [...section.fields];
				fieldsToUpdate.forEach((field) => {
					field.value = this.parseValue(field, customSectionFieldValues[field.id]);
				});
			}
		});

		return customSectionsToUpdate;
	}

	static errorValidation(field, value) {
		const error = {
			hasError: false,
			errMsg: "",
		};

		if (field.required && this.isEmpty(value)) {
			error.hasError = true;
			return error;
		}

		switch (field.type) {
			case "checkbox":
				return error;
			case "email":
				if (!this.isEmpty(value) && !isValidEmail(value)) {
					error.hasError = true;
					return error;
				}
				break;
			default:
				break;
		}

		if (!this.isEmpty(value) && Array.isArray(field.validation)) {
			field.validation.forEach((v) => {
				if (!this.isEmpty(v)) {
					const validation = v.split("::");
					if (validation.length > 0) {
						switch (validation[0]) {
							case "pattern":
								if (!new RegExp(validation[1]).test(value)) {
									error.hasError = true;
								}
								break;
							default:
								break;
						}
					}
				}
			});
		}

		return error;
	}

	static validateCustomSections(customSections) {
		const customSectionsToUpdate = [...customSections];
		customSectionsToUpdate.forEach((section, idx) => {
			if (Array.isArray(section.fields)) {
				const fieldsToUpdate = [];
				[...section.fields].forEach((field) => {
					fieldsToUpdate.push({
						...field,
						...this.errorValidation(field, field.value),
					});
				});
				customSectionsToUpdate[idx].fields = fieldsToUpdate;
			}
		});

		return customSectionsToUpdate;
	}

	static hasInvalidcustomSectionField(customSections) {
		let hasInvalidField = false;
		if (Array.isArray(customSections)) {
			const customSectionsToUpdate = this.validateCustomSections(customSections);
			customSectionsToUpdate.forEach((section) => {
				if (Array.isArray(section.fields)) {
					section.fields.forEach((field) => {
						if (field.hasError) {
							hasInvalidField = true;
						}
					});
				}
			});
		}

		return hasInvalidField;
	}

	static enrichWithTerminationDetailValues(section, terminationDetails) {
		if (terminationDetails) {
            section.fields.forEach((field) => {
                switch (field.id) {
					case "terminationDate":
                    case "dateOfTermination":
                        field["value"] = Utility.formatDate(terminationDetails[field.id], FORMAT.DDMMYYYY, "DD MMM YYYY") || "";
                        break;
					case "terminationReason":
                    case "terminationType":
					case "exitInterviewFeedback":
					case "clearanceFromEachDept":
						const option = field.options.find(o => o.id === terminationDetails[field.id]);
						if (option) {
							field["value"] = option.name;
						} else {
							field["value"] = terminationDetails[field.id] || "";
						}
                        break;
                    default:
						field["value"] = terminationDetails[field.id] || "";
                        break;
                }
            });
        }

		return section;
	}
}

export default CustomSectionManager;
